module.exports = {"data":"user","user":"person","token":"sk","username":"username","name":"fullname","permissions":"roles","modules":"menu","type":"type","subscription":"subscription","domain":"marketTypeID","billpay":"billpay","p2p":"p2p","theme":"theme","claims":"permissions","userPermissions":"userPermissions","flags":"flags","created":"dateCreated","settings":"settings","dateFormat":"dateFormat","hasPC":"hasPC","invoicePrefHidden":"invoicePrefHidden","isDell":"isDell","hasBankAccount":"hasBankAccount"}


//////////////////
// WEBPACK FOOTER
// ./src/core/user/map.json
// module id = 81Tg
// module chunks = 12